module.exports = __webpack_public_path__ + "img/img3.a53e0a25.jpg";